/**
 * Normalize GET /billing/exports list items for UI tables.
 *
 * API shape example:
 * `{ id, type, format, status, rowCount, fileName, date, exportedBy, filters, filtersJson, errorMessage, fileUrl }`
 */
export function normalizeExportHistoryItem(raw) {
  if (!raw || typeof raw !== "object") return null;
  const id = raw.id != null ? String(raw.id) : undefined;
  if (!id) return null;

  const status = String(raw.status ?? "").toLowerCase();
  const fileUrl =
    typeof raw.fileUrl === "string" && raw.fileUrl.trim() !== "" ? raw.fileUrl.trim() : null;

  return {
    id,
    type: raw.type != null ? String(raw.type) : "",
    format: raw.format != null ? String(raw.format).toUpperCase() : "",
    status,
    rowCount: Number(raw.rowCount) || 0,
    fileName: raw.fileName != null ? String(raw.fileName) : "",
    date: raw.date != null ? String(raw.date) : "—",
    exportedBy: raw.exportedBy != null ? String(raw.exportedBy) : "—",
    filters: raw.filters != null && String(raw.filters).trim() !== "" ? String(raw.filters) : "—",
    filtersJson: raw.filtersJson,
    errorMessage: raw.errorMessage != null ? String(raw.errorMessage) : null,
    /** Presigned URL when API returns one (optional; download uses GET /billing/exports/:id/download) */
    fileUrl,
    /** Successful exports are downloaded via GET /billing/exports/:id/download (Bearer) */
    canDownload: status === "success",
  };
}

export function normalizeExportHistoryItems(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeExportHistoryItem).filter(Boolean);
}

/** Display label for status column (e.g. `success` → Success) */
export function formatExportStatusLabel(status) {
  if (!status) return "—";
  return String(status).charAt(0).toUpperCase() + String(status).slice(1);
}
